import React, { useEffect, useState } from 'react';
import axios from '../../config/axiosConfig';
import { MdAdd, MdPhotoLibrary, MdEdit, MdDelete } from 'react-icons/md';

const DashboardGallery = ({ onAddClick, onEditClick }) => {
    const [galleries, setGalleries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchGalleries();
    }, []);

    const fetchGalleries = async () => {
        try {
            const response = await axios.get('nai-gallery/');
            setGalleries(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching galleries:", error);
            setLoading(false);
        }
    };

    const handleDelete = async (id, e) => {
        e.stopPropagation();
        if (window.confirm("Are you sure you want to delete this album? This cannot be undone.")) {
            try {
                await axios.delete(`nai-gallery/${id}/`);
                setGalleries((prev) => prev.filter(g => g.id !== id));
            } catch (error) {
                console.error("Error deleting gallery:", error);
                alert("Failed to delete gallery.");
            }
        }
    };

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-800">NAI Gallery (Albums)</h2>
                <button
                    onClick={onAddClick}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center"
                >
                    <MdAdd className="mr-2" /> Create Album
                </button>
            </div>

            {loading ? (
                <div>Loading galleries...</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {galleries.map((gallery) => (
                        <div key={gallery.id} className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow group relative">
                            <div className="h-48 bg-gray-100 rounded-t-lg overflow-hidden relative">
                                {gallery.images && gallery.images.length > 0 ? (
                                    <img 
                                        src={gallery.images[0].image} 
                                        alt={gallery.title} 
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="flex items-center justify-center h-full text-gray-400">
                                        <MdPhotoLibrary className="w-12 h-12" />
                                    </div>
                                )}
                                <div className="absolute bottom-0 right-0 bg-black/60 text-white text-xs px-2 py-1 rounded-tl-md">
                                    {gallery.images ? gallery.images.length : 0} Items
                                </div>
                            </div>
                            <div className="p-4 pb-12">
                                <h3 className="font-bold text-lg text-gray-900 truncate">{gallery.title}</h3>
                                {gallery.description && (
                                    <p className="text-sm text-gray-500 mt-1 line-clamp-2">{gallery.description}</p>
                                )}
                                <div className="mt-3 text-xs text-gray-400">
                                    {new Date(gallery.created_at).toLocaleDateString()}
                                </div>
                            </div>
                            
                            {/* Actions Overlay */}
                            <div className="absolute bottom-3 right-3 flex space-x-2">
                                <button 
                                    onClick={() => onEditClick(gallery.id)}
                                    className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200 transition-colors"
                                    title="Edit Album"
                                >
                                    <MdEdit size={18} />
                                </button>
                                <button 
                                    onClick={(e) => handleDelete(gallery.id, e)}
                                    className="p-2 bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
                                    title="Delete Album"
                                >
                                    <MdDelete size={18} />
                                </button>
                            </div>
                        </div>
                    ))}
                    {galleries.length === 0 && (
                        <div className="col-span-full text-center py-12 text-gray-500">
                            No albums created yet. Click "Create Album" to start.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DashboardGallery;
